/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopQuestionnaireQuestionReport', 'model/WorkshopQuestionnaireQuestion'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopQuestionnaireQuestionReport'), require('../model/WorkshopQuestionnaireQuestion'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopQuestionnaireQuestionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopQuestionnaireQuestionReport, root.ForStractionServiceApi.WorkshopQuestionnaireQuestion);
  }
}(this, function(ApiClient, WorkshopQuestionnaireQuestionReport, WorkshopQuestionnaireQuestion) {
  'use strict';

  /**
   * WorkshopQuestionnaireQuestion service.
   * @module api/WorkshopQuestionnaireQuestionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopQuestionnaireQuestionApi. 
   * @alias module:api/WorkshopQuestionnaireQuestionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopQuestionnaireQuestionAddAllPut operation.
     * @callback module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkshopQuestionnaireQuestionReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopQuestionnaireQuestionReport>} body 
     * @param {module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkshopQuestionnaireQuestionReport>}
     */
    this.workshopQuestionnaireQuestionAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopQuestionnaireQuestionAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopQuestionnaireQuestionAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkshopQuestionnaireQuestionReport];

      return this.apiClient.callApi(
        '/WorkshopQuestionnaireQuestion/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopQuestionnaireQuestionDeleteAllPut operation.
     * @callback module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopQuestionnaireQuestionDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopQuestionnaireQuestionDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopQuestionnaireQuestionDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopQuestionnaireQuestion/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopQuestionnaireQuestionEditAllPut operation.
     * @callback module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopQuestionnaireQuestion>} body 
     * @param {module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopQuestionnaireQuestionEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopQuestionnaireQuestionEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopQuestionnaireQuestionEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopQuestionnaireQuestion/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopQuestionnaireQuestionLoadGet operation.
     * @callback module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopQuestionnaireQuestionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopQuestionnaireQuestionApi~workshopQuestionnaireQuestionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopQuestionnaireQuestionReport}
     */
    this.workshopQuestionnaireQuestionLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopQuestionnaireQuestionLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopQuestionnaireQuestionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopQuestionnaireQuestionReport;

      return this.apiClient.callApi(
        '/WorkshopQuestionnaireQuestion/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
